import { render, staticRenderFns } from "./ShipmentDetail.vue?vue&type=template&id=729f1fa8"
import script from "./ShipmentDetail.vue?vue&type=script&lang=js"
export * from "./ShipmentDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports